exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".explore__badge {\n  display: inline-block;\n  position: absolute;\n  min-width: 4px;\n  padding: 1px 4px;\n  font-size: 12px;\n  line-height: 1;\n  color: #e0e0e0;\n  color: hsla(var(--ui-03-h, 0), var(--ui-03-s, 0%), var(--ui-03-l, 87.84314%), 1);\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  background-color: #161616;\n  background-color: hsla(var(--icon-01-h, 0), var(--icon-01-s, 0%), var(--icon-01-l, 8.62745%), 1);\n  border-radius: 10px;\n  top: 0px;\n  right: -2px;\n}\n\n.explore__badge_empty {\n  visibility: hidden;\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-1!./node_modules/postcss-loader??ref--2-2!./node_modules/resolve-url-loader!./node_modules/sass-loader/lib/loader.js??ref--2-4!./src/js/components/badge/Badge.scss
// module id = 323
// module chunks = 0